export { default } from "./UserAvatar";
